<template>
  <!-- ブラウザ自動翻訳(Chrome/Google翻訳)がテキストノードを差し替えるとVueの再描画と競合し、
       月見出しが全て同一(例: 2026年7月)に潰れる。日付・曜日・数字は翻訳不要なのでこのカレンダー配下を翻訳対象外にする -->
  <div class="notranslate h-full w-full font-Spectral" translate="no">
    <div class="absolute left-0 mb-4 grid w-full grid-cols-7 gap-x-7 bg-white px-8 py-2 text-center text-[13px] font-light leading-none text-stone-500 md:px-14">
      <div v-for="week in props.lang === 'jp' ? WEEKDAY_LIST : WEEKDAY_LIST_EN" :key="week">
        <span> {{ week }} </span>
      </div>
    </div>
    <div class="pt-6">
      <div v-for="(week, i) in calendarRowList" :key="i">
        <!-- 生成時点で月の１週目を計算するので、その値を参照するだけ-->
        <div v-if="week[0].isFirstWeek">
          <p class="mt-4 text-base font-medium leading-normal text-stone-700">{{ week[0].yearMonthLabel }}</p>
        </div>
        <Border1 v-if="!week[0].isFirstWeek" />
        <div class="grid grid-cols-7 py-1">
          <CalendarDate
            v-for="({ day, isDisabled, isCurrentMonth }, j) in week"
            :key="j"
            :calendar-day="day"
            :disabled="isDisabled"
            :hidden="!isCurrentMonth"
            :is-selected="selectedDates.has(day)"
            @click-date="onClickDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Border1 from '@/components/atoms/Border1/Border1.vue';
import CalendarDate from '@/components/molecules/CalendarDate/CalendarDate.vue';
import { useDatePickerCalendar } from '@/composables/ui/useDatePickerCalendar';
import type { Lang } from '@/models/lang';
import { WEEKDAY_LIST, WEEKDAY_LIST_EN } from '@/wabunka-src/constants/calendar';

interface Props {
  lang?: Lang;
  defaultSelect: string[];
}

const props = withDefaults(defineProps<Props>(), {
  lang: 'en',
});

const emits = defineEmits<{ (e: 'selectionChange', dates: Map<string, string>): void }>();

const selectedDates = ref<Map<string, string>>(new Map(props.defaultSelect.map((date: string) => [date, date])));

const onClickDate = (date: string) => {
  if (selectedDates.value.has(date)) {
    selectedDates.value.delete(date);
  } else {
    selectedDates.value.set(date, date);
  }
  emits('selectionChange', selectedDates.value);
};

/** カレンダー描画用 */
const { calendarRowListState: calendarRowList } = useDatePickerCalendar();
</script>
